import * as React from "react";
import { observer } from "mobx-react";
import { contactsStore } from "Stores/ContactsStore";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { formatUsername } from "utils/formatUsername";

interface UserNameProps extends WithTranslation {
  id: number;
  username?: boolean;
  /* Wether return empty string of contact not foun */
  hideIfNotFound?: boolean;
  fallback?: string;
}

export const UserName = withTranslation(I18N_NS.GENERAL)(
  observer(
    class extends React.Component<UserNameProps> {
      public render() {
        const { t, username, hideIfNotFound, fallback } = this.props;
        if (contactsStore.state === "LOADING") {
          return t("Loading...");
        }

        const user = contactsStore.getUserById(+this.props.id);
        let name = fallback || t("Contact not Found");

        if (user) {
          name = username ? user.userId : ` ${formatUsername({ firstName: user.firstName, surname: user.surname })}`;
        } else if (hideIfNotFound) {
          name = null;
        }

        return <span title={name}>{name}</span>;
      }
    }
  )
);
